import { MARQUEE_ITEMS } from "../data/brand";

// Brand-color diamond cycle — "secondary colors work best as backgrounds and
// color variations for messaging graphics" (Tacoverse brand style guide).
const DIAMONDS = ["bg-bv-flame", "bg-bv-pink", "bg-bv-gold", "bg-bv-sky", "bg-bv-green"];

function Track({ hidden }) {
  return (
    <ul aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {MARQUEE_ITEMS.map((item, i) => (
        <li key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-2xl uppercase text-bv-ink md:text-4xl">
            {item}
          </span>
          <span
            className={`inline-block h-2 w-2 rotate-45 ${DIAMONDS[i % DIAMONDS.length]}`}
            aria-hidden="true"
          />
        </li>
      ))}
    </ul>
  );
}

// One slow editorial marquee — items appear once per loop, second track is
// purely for the seamless drift and hidden from screen readers.
export default function Marquee({ className = "" }) {
  return (
    <div className={`overflow-hidden bg-bv-gold py-4 md:py-5 ${className}`} data-testid="marquee">
      <div className="marquee-track flex w-max">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}
